"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolbarDatePeriodFilter = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const controls_1 = require("../../controls");
function toolbarDatePeriodFilter(_a) {
    var { startProperty, endProperty, groupId = '', disabled, decorators, texts, startDatetime, endDatetime } = _a, rest = __rest(_a, ["startProperty", "endProperty", "groupId", "disabled", "decorators", "texts", "startDatetime", "endDatetime"]);
    return {
        decorators,
        disabled,
        render: (model, { disabled }) => {
            return (react_1.default.createElement(core_1.ModelRenderer, { model: model, render: ({ value: { filters } }) => {
                    const startFilterValue = filters.getFilterValue({
                        property: startProperty,
                        groupId
                    });
                    const endFilterValue = filters.getFilterValue({
                        property: endProperty,
                        groupId
                    });
                    const value = startFilterValue && endFilterValue
                        ? [
                            new Date(startFilterValue),
                            new Date(endFilterValue)
                        ]
                        : [];
                    return (react_1.default.createElement(controls_1.DatePeriod, Object.assign({ value: value, texts: texts, startDatetime: startDatetime, endDatetime: endDatetime, disabled: disabled, onChange: (value) => {
                            if (!value.length) {
                                model.setFilter({ property: startProperty, groupId }, null);
                                model.setFilter({ property: endProperty, groupId }, null);
                                return;
                            }
                            let start = value[0];
                            start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            let end = new Date(value[1] || value[0]);
                            end.setHours(24, 0, 0, 0);
                            end = new Date(end.valueOf() - 1);
                            model.setFilter({ property: startProperty, groupId }, {
                                value: start.toISOString(),
                                operation: core_1.FILTER_OPERATION.greaterThanOrEqual,
                                collation: core_1.FILTER_COLLATION.ignorecase
                            });
                            model.setFilter({ property: endProperty, groupId }, {
                                value: end.toISOString(),
                                operation: core_1.FILTER_OPERATION.lessThanOrEqual,
                                collation: core_1.FILTER_COLLATION.ignorecase
                            });
                        } }, rest)));
                } }));
        }
    };
}
exports.toolbarDatePeriodFilter = toolbarDatePeriodFilter;
//# sourceMappingURL=toolbarDatePeriodFilter.js.map